import { getStore } from '~/mobx/AppStore';

export const getIsLoading = () => {
    const { regionStore } = getStore();
    return regionStore.isLoadingRegions || regionStore.isDeletingRegions || regionStore.isCreatingRegion;
};
